// ======================================================================
// DOCUMENT READY
// ======================================================================

$(document).ready(function() {
  console.log('%c******************** DOCUMENT READY ********************', 'font-weight:bold;color:#c70284;');
  // modernizr
  // if (typeof Modernizr !== 'undefined') {
  //   console.log('%c*** MODERNIZR ***', 'color:#098c0c;');
  //   console.log(Modernizr);
  // }
  // update data
  if (typeof $ !== 'undefined' && typeof $device.init !== 'undefined') $device.init();
  // views
  if (typeof $pages !== 'undefined' && typeof $pages.init !== 'undefined') $pages.init();
  if (typeof $popups !== 'undefined' && typeof $popups.init !== 'undefined') $popups.init();
  // bind events
  if (typeof $events !== 'undefined' && typeof $events.init !== 'undefined') $events.init();
  if (typeof $windowsize !== 'undefined' && typeof $windowsize.run !== 'undefined') $windowsize.run(true);
  // general app init
  if (typeof $utils !== 'undefined' && typeof $utils.init !== 'undefined') $utils.init();
  if (typeof $animate !== 'undefined' && typeof $animate.init !== 'undefined') $animate.init();
  if (typeof $cursors !== 'undefined' && typeof $cursors.init !== 'undefined') $cursors.init();
  if (typeof $hijax !== 'undefined' && typeof $hijax.init !== 'undefined') $hijax.init();
  if (typeof $nav !== 'undefined' && typeof $nav.init !== 'undefined') $nav.init();
  if (typeof $scroll !== 'undefined' && typeof $scroll.init !== 'undefined') $scroll.init();
  if (typeof $thumbs !== 'undefined' && typeof $thumbs.init !== 'undefined') $thumbs.init();
});

// ======================================================================
// WINDOW LOADED
// ======================================================================

$(window).on('load', function() {
  console.log('%c******************** WINDOW LOADED ********************', 'font-weight:bold;color:#c70284;');
  // preload
  if (typeof $preload !== 'undefined' && typeof $preload.init !== 'undefined') $preload.init();
  // bind events
  if (typeof $windowsize !== 'undefined' && typeof $windowsize.run !== 'undefined') $windowsize.run(true);
});

// ======================================================================
// WINDOW RESIZE
// ======================================================================

$(window).resize(function() {
  // bind events
  if (typeof $windowsize !== 'undefined' && typeof $windowsize.run !== 'undefined') $windowsize.run();
});

// ======================================================================
// WINDOW SCROLL
// ======================================================================

// $(window).scroll(function() {
//   // bind events
//   if (typeof $scroll !== 'undefined' && typeof $scroll.run !== 'undefined') $scroll.run();
// });

// ======================================================================
// WINDOW BLUR / FOCUS
// ======================================================================

// $(window).blur(function() {});
// $(window).focus(function() {});

// ======================================================================
// DEV
// ======================================================================

$(document).ready(function() {
  if ($el('body').hasClass('dev')) {
    $('.page__body').each(function() {
      var count = 1;
      $(this)
        .find('img')
        .each(function() {
          $('<span class="u-dev-img"><span>' + count + '</span></span>').insertAfter($(this));
          count++;
        });
    });
  }
});

// var mutationObserver = new MutationObserver(function(mutations) {
//   mutations.forEach(function(mutation) {
//     console.log(mutation);
//   });
// });
//
// mutationObserver.observe(document.documentElement, {
//   attributes: true,
//   characterData: true,
//   childList: true,
//   subtree: true,
//   attributeOldValue: true,
//   characterDataOldValue: true
// });
